/*
 * Answers Audit History Component
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2022 Gallagher Bassett Services, Inc.
 */

import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { take } from 'rxjs/operators';
import {
  AuditHistoryService,
  IncidentService
} from 'app/shared/services';
import { AnswersAuditHistoryRecord } from 'app/shared/models/answers-audit-history.model';

@Component ( {
    selector: 'reporter-answers-audit-history',
    templateUrl: './answers-audit-history.component.html',
    styleUrls: ['./answers-audit-history.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
} )
export class AnswersAuditHistoryComponent implements OnInit {
  @Input () incidentId: string;
  @Output () close = new EventEmitter<any> ();

  auditHistory: AnswersAuditHistoryRecord[];
  pageNumber = 1;
  readonly pageSize = 50;
  totalPages = 0;
  totalRecords = 0;
  @ViewChild ( 'resultsBody', { static: false } ) resultsBody: ElementRef;
  noScrollbar: boolean;

  constructor( private service: IncidentService ) {
  }

  async ngOnInit() {
    this.auditHistory = [];
    this.getHistoryPage ();
  }

  getHistoryPage() {
    this.service.getIncidentAnswersAuditHistory ( this.incidentId, this.pageNumber, this.pageSize ).pipe ( take ( 1 ) )
      .subscribe ( result => {
        this.auditHistory.push ( ...result.records );
        this.totalPages = result.totalPages;
        this.totalRecords = result.totalRecords;
        setTimeout ( () => {
          this.noScrollbar = this.resultsBody?.nativeElement.scrollHeight <= this.resultsBody?.nativeElement.clientHeight;
        }, 0 );
      } );
  }

  loadNextPage() {
    if ( this.pageNumber < this.totalPages ) {
      this.pageNumber++;
      this.getHistoryPage ();
    }
  }
}
